var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallBlackLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C6.65685 3.22167e-08 8 1.34315 8 3V4.44141C8.45171 4.73948 8.74989 5.25135 8.75 5.83301V8.33301C8.75 9.25348 8.00348 10 7.08301 10H2.91699C1.99652 10 1.25 9.25348 1.25 8.33301V5.83301C1.25011 5.25135 1.54829 4.73948 2 4.44141V3C2 1.34315 3.34315 0 5 0ZM5 1C3.89543 1 3 1.89543 3 3V4.16699H7V3C7 1.89543 6.10457 1 5 1Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBlackLock);
export default __webpack_public_path__ + "static/media/small-black-lock.02f2ed1807e6e7acabd130bc538f4b17.svg";
export { ForwardRef as ReactComponent };